module.exports = __webpack_public_path__ + "img/sidebar-room-enter.789bd73c.svg";